// 验证页面翻译
export default {
  title: "账号验证",
  subtitle: "请完成账号验证以继续使用",
  emailVerification: "邮箱验证",
  phoneVerification: "手机验证",
  twoFactorAuth: "两步验证",
  sendVerificationEmail: "发送验证邮件",
  sendVerificationSMS: "发送短信验证码",
  resendCode: "重新发送",
  verifyButton: "验证",
  skipVerification: "跳过验证",
  verificationSuccess: "验证成功",
  verificationFailed: "验证失败",
  codeIncorrect: "验证码不正确",
  form: {
    emailCode: "邮箱验证码",
    smsCode: "短信验证码",
    authCode: "身份验证码",
    emailCodeRequired: "请输入邮箱验证码",
    smsCodeRequired: "请输入短信验证码",
    authCodeRequired: "请输入身份验证码",
    codeFormat: "请输入{length}位验证码",
  },
  tips: {
    emailSent: "验证邮件已发送至 {email}",
    smsSent: "验证码已发送至 {phone}",
    checkSpam: "如未收到邮件，请检查垃圾邮件文件夹",
    codeExpiry: "验证码将在{minutes}分钟后过期",
  },
};
